module.exports = __webpack_public_path__ + "static/media/godsnlegends.c56bb87f.webp";